export default "__VITE_ASSET__COjQE3Jc__"